export default __webpack_public_path__ + "./image/a9bfb2b99319529bb5ce4aebe7ac16e7.png";